import Vue from "vue";
import VueGtm from 'vue-gtm';
import App from "./App";
import "./registerServiceWorker";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import Vuelidate from 'vuelidate';
import FlashMessage from '@smartweb/vue-flash-message';
import Axios from '@/http'
import money from 'v-money';
import VModal from 'vue-js-modal'
import Inputmask from 'inputmask';
import { EventBus } from '@/utils/EventBus';


Vue.prototype.$dataLayer = window.dataLayer || [];

router.afterEach(() => {
  try {
    const rawUserData = localStorage.getItem("userData");
    const rawCredor = localStorage.getItem("credor");
    const userDataStorage = rawUserData ? JSON.parse(rawUserData) : null;
    const credor = rawCredor ? JSON.parse(rawCredor) : null;

    const protocol = window.location.protocol;
    const host = window.location.host;
    const path = window.location.pathname;
    const pageLocationURL = protocol + '//' + host + path;
    let pageLocation = userDataStorage ? userDataStorage.page_location : pageLocationURL;
    if(credor == 2){
      pageLocation = protocol + '//' + host + "/jornada-amigavel" + path;
    }

    const utmData = store.getters['utm/asDataLayerObject'];
    Vue.prototype.$dataLayer.push({ event: 'page-view', page_location: pageLocation, ...utmData });
  } catch (e) {
    // tracking não pode quebrar navegação
  }
});

Vue.use(VueGtm, {
  id: 'GTM-W6RMTFS',
  customDataLayer: Vue.prototype.$dataLayer, // Observe que 'dataLayer' é uma variável global do Google Tag Manager.
});

Vue.use(Inputmask);

// register directive v-money and component <money>
Vue.use(money,  {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false
});


Vue.use(Axios);

Vue.use(FlashMessage);

Vue.use(VModal);

Vue.config.productionTip = false;





const customData = (object, friendlyPageName) => {
  return { 
    page: {
      name: friendlyPageName,
    },
    site: {
      versao: process.env.VUE_APP_VERSION,
      channel: 'portal-de-negociacao',
    },
    user: {
      id: object.cpfCnpj,
      logged: false, // Defina como true ou false, dependendo do status de login do usuário.
    },
    page_location: object.page_location
  }
};



new Vue({
  router,
  store,
  vuetify,
  
  Vuelidate,
  render: (h) => h(App),
  created() {
    // Escute o evento personalizado globalmente
    this.$root.$on('updatePageView', () => {
      try {
        const rawUserData = localStorage.getItem("userData");
        const rawCredor = localStorage.getItem("credor");
        const userDataStorage = rawUserData ? JSON.parse(rawUserData) : null;
        const credor = rawCredor ? JSON.parse(rawCredor) : null;

        const protocol = window.location.protocol;
        const host = window.location.host;
        const path = window.location.pathname;
        const pageLocationURL = protocol + '//' + host + path;
        let pageLocation = userDataStorage ? userDataStorage.page_location : pageLocationURL;
        if(credor == 2){
          pageLocation = protocol + '//' + host + "/jornada-amigavel" + path;
        }
        const utmData = store.getters['utm/asDataLayerObject'];
        this.$dataLayer.push({ event: 'page-view', page_location: pageLocation, ...utmData });
      } catch (e) {
        // tracking não pode quebrar navegação
      }
    });

    EventBus.$on('updatePageView', (friendlyPageName) => {
      try {
        const rawUserData = localStorage.getItem("userData");
        const rawCredor = localStorage.getItem("credor");
        const userDataStorage = rawUserData ? JSON.parse(rawUserData) : null;
        const credor = rawCredor ? JSON.parse(rawCredor) : null;

        const protocol = window.location.protocol;
        const host = window.location.host;
        const path = window.location.pathname;
        const pageLocationURL = protocol + '//' + host + path;
        let pageLocation = userDataStorage ? userDataStorage.page_location : pageLocationURL;
        if(credor == 2){
          pageLocation = protocol + '//' + host + "/jornada-amigavel/" + friendlyPageName;
        }
        if (userDataStorage) {
          customData(userDataStorage, friendlyPageName);
        }
        const utmData = store.getters['utm/asDataLayerObject'];
        this.$dataLayer.push({ event: 'page-view', page_location: pageLocation, ...utmData });
      } catch (e) {
        // tracking não pode quebrar o fluxo de login
      }
    });


  },
}).$mount("#app");
